import { render } from "./CustomerSummary.vue?vue&type=template&id=41b17e23&ts=true"
import script from "./CustomerSummary.vue?vue&type=script&lang=ts"
export * from "./CustomerSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__